import { AppContextModel } from '../types/types'

let appContextValue: AppContextModel | undefined

export const setAppContext = (value: AppContextModel) => {
	appContextValue = value
}

export const getAppContext = (): AppContextModel => {
	if (!appContextValue) {
		throw new Error('App context is not initialized yet.')
	}
	return appContextValue
}
